import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5100';

const api = axios.create({ baseURL: BASE_URL });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
